import React, { useEffect, useState } from 'react'
import { RightArrowIcon } from '@ow/icons'
import clsx from 'clsx'
import { defaultTheme } from '@ow/theme'
import {
  StyledMenuContent,
  StyledMenuContentNavItem,
  StyledMenuContentNavItemChildren,
} from '../styled/menu-vertical'
import IconRender from '../icon-render'
import RenderIf from '../../../render-if'
import { getCurrentUrl, setDataHighlightState } from '../../utils'

const MenuContent = (props) => {
  const {
    backgroundColor,
    textColor,
    menuData,
    collapse,
    hoverFontColor,
    onMenuClick,
    renderNavLevel,
    bottomComponent,
  } = props

  const [_menuData, setMenuData] = useState(menuData)
  const isRenderAllLevel = renderNavLevel === 2

  useEffect(() => {
    const data = setDataHighlightState(menuData, isRenderAllLevel)
    setMenuData(data)
  }, [menuData])

  const getChildrenIsOpen = (nav, idx, index) => {
    nav.isOpen = idx === index ? !nav.isOpen : false
    return nav
  }
  // 打开/关闭 二级导航 || 跳转页面
  const handleParentClick = (navParent, index) => {
    let arr = []
    if (!isRenderAllLevel || !navParent.children) {
      // 如果指定渲染1级 || 当前导航没有子级
      onMenuClick(navParent)
    } else {
      arr = (_menuData || []).map((nav, idx) =>
        getChildrenIsOpen(nav, idx, index)
      )
    }
    setMenuData(arr)
  }

  const handleThirdChildren = (navChild) => {
    onMenuClick(navChild)
  }

  return (
    <StyledMenuContent
      backgroundColor={backgroundColor}
      hoverFontColor={hoverFontColor}
      textColor={textColor}
    >
      <div>
        {(_menuData || []).map((nav, index) => {
          return (
            nav.show && (
              <StyledMenuContentNavItem
                onClick={() => {
                  handleParentClick(nav, index)
                }}
                // FIXME: 这里得处理下 key 的内容
                collapse={collapse}
                hoverFontColor={hoverFontColor}
                theme={defaultTheme}
                key={nav.url}
              >
                {/* 一级菜单 左侧 icon+name */}
                <div
                  className={clsx({
                    'menu-first-level': true,
                    'menu-vertical-nav-item-active':
                      nav.isActive || getCurrentUrl().includes(nav.matchUrl),
                  })}
                >
                  <div className="menu-first-level-left">
                    <IconRender
                      style={{ marginRight: '12px' }}
                      url={nav.icon}
                      fill={
                        nav.isActive || getCurrentUrl().includes(nav.matchUrl)
                          ? hoverFontColor
                          : '#787d86'
                      }
                    />
                    <span
                      style={{ opacity: `${collapse ? '0' : '1'}` }}
                      className={clsx({
                        'menu-name': true,
                      })}
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: nav.name }}
                    />
                  </div>
                  {/* 箭头 */}
                  <RenderIf
                    isTrue={nav.children && !collapse && isRenderAllLevel}
                  >
                    <div
                      style={{
                        transition: `all 350ms ease`,
                        transform:
                          `scale(0.8) ${nav.isOpen ? 'rotate(90deg)' : ''}` ||
                          'unset',
                      }}
                    >
                      <RightArrowIcon fill="#6f757c" />
                    </div>
                  </RenderIf>
                </div>

                {/* 对应children */}
                <RenderIf isTrue={nav.children && !collapse}>
                  <StyledMenuContentNavItemChildren
                    textColor={textColor}
                    theme={defaultTheme}
                    hoverFontColor={hoverFontColor}
                    style={{
                      height: `${
                        nav.isOpen ? `${33 * nav.children.length}px` : '0px'
                      }`,
                    }}
                    onClick={(e) => {
                      e.stopPropagation()
                    }}
                  >
                    {nav.children &&
                      nav.children.map((navChild) => {
                        return (
                          <div
                            className={clsx({
                              'ow-text-inverse-color': true,
                              'hover:text-primary': true,
                              'menu-vertical-nav-child-item-active':
                                getCurrentUrl().includes(navChild.matchUrl) ||
                                navChild.isActive,
                            })}
                            key={navChild.url}
                            // FIXME: key 的内容得处理一下
                            onClick={(e) => {
                              e.stopPropagation()
                              handleThirdChildren(navChild)
                            }}
                          >
                            {navChild.name}
                          </div>
                        )
                      })}
                  </StyledMenuContentNavItemChildren>
                </RenderIf>
              </StyledMenuContentNavItem>
            )
          )
        })}
      </div>
      {/* 底部组件 */}
      {bottomComponent}
    </StyledMenuContent>
  )
}

export default MenuContent
